import axios from "axios";
import authHeader from "@/services/auth-header";
import config from "@/data/config";
import model from "@/data/model";

const API_URL = config.baseURL;
const myModel = model.kk;

export const configuration = {
   namespaced: true,
   state: {
      data: [],
      item: { ...myModel },
      pastor: [],
   },
   getters: {
      // countAll: (state) => {return state.data.length},
      countAll(state) {
         return state.data.length;
      },
      getById: (state) => (id) => {
         return state.data.find((data) => data.id === id);
      },
   },
   actions: {
      async getPastorAll({ commit, rootState }) {
         rootState.isLoading = true;
         commit("REMOVE_ALL");
         await axios
            .get(`${API_URL}config_pastor`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  commit("SET_DATA", response.data);
                  rootState.isLoading = false;
               },
               () => {
                  rootState.isLoading = false;
               }
            );
      },
      async getPastor({ rootState }, id) {
         rootState.isLoading = true;
         return await axios
            .get(`${API_URL}config_pastor/${id}`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async savePastor({ rootState }, data) {
         rootState.isLoading = true;
         return await axios
            .post(`${API_URL}config_pastor`, data, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async deletePastor({ rootState }, id) {
         rootState.isLoading = true;
         return await axios
            .delete(`${API_URL}config_pastor/${id}`, {
               headers: authHeader(),
            })
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
      async setPastor({ rootState }, id) {
         rootState.isLoading = true;
         return await axios
            .put(
               `${API_URL}config_pastor_set/${id}`,
               {},
               {
                  headers: authHeader(),
               }
            )
            .then(
               (response) => {
                  rootState.isLoading = false;
                  return Promise.resolve(response);
               },
               (error) => {
                  rootState.isLoading = false;
                  return Promise.reject(error);
               }
            );
      },
   },
   mutations: {
      SET_DATA(state, data) {
         state.pastor = data;
      },
      REMOVE_ALL(state) {
         state.pastor = null;
      }
   },
};
